import { Excel, Pdf, Placeholder, Txt, Word, Ppt, Zip, Rar, Csv, Xls, Html, Cad } from "../../../../../assets/images";

const getFile = (fileType, extension) => {
  const getLowercase = extension ? extension.toString().toLowerCase() : "";
  if (getLowercase === ".doc" || getLowercase === ".docx" || fileType === "application/msword") {
    return Word;
  } else if (
    getLowercase === ".xlsx" ||
    fileType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ) {
    return Excel;
  } else if (
    getLowercase === ".xls" ||
    fileType === "application/vnd.ms-excel" ||
    fileType === "application/excel" ||
    fileType === "application/x-excel" ||
    fileType === "application/x-msexcel"
  ) {
    return Xls;
  } else if (getLowercase === ".txt" || fileType === "text/plain") {
    return Txt;
  } else if (getLowercase === ".pdf" || fileType === "application/pdf") {
    return Pdf;
  } else if (getLowercase === ".csv" || fileType === "application/csv") {
    return Csv;
  } else if (
    getLowercase === ".ppt" ||
    getLowercase === ".pptx" ||
    fileType === "application/ppt" ||
    fileType === "application/pptx"
  ) {
    return Ppt;
  } else if (getLowercase === ".zip" || fileType === "application/zip" || fileType === "application/x-zip-compressed") {
    return Zip;
  } else if (getLowercase === ".rar" || fileType === "application/rar" || fileType === "application/vnd.rar") {
    return Rar;
  } else if (getLowercase === ".html" || getLowercase === ".htm" || fileType === "text/html") {
    return Html;
  } else if (
    [".dxf", ".dwg", ".dwt", ".stl", ".igs", ".iges", ".stp", ".step"].includes(getLowercase) ||
    ["image/vnd.dxf", "image/vnd.dwg", "model/stl", "application/sla", "application/vnd.ms-pki.stl", "model/iges", "model/step"].includes(fileType)
  ) {
    return Cad;
  } else {
    return Placeholder;
  }
};

const getFileFromType = (fileType, extension) => {
  return getFile(fileType, extension);
};

export default getFileFromType;
